<template >
    <div class="body d-flex py-lg-3 py-md-2 mb-5" v-if="hasMarketingHub">
        <div class="container-xxl">
            
                           
<div class="row text-center g-3">
   <!-- Lists -->
  <div class="col-6 col-md-6 col-lg-2"v-if="(canViewLists || superUser) && hasMarketingHub">
    <RouterLink to="/lists" class="menu-box d-block">
      <div class="menu-content">
         <i class="icofont-list menu-img mb-2 mt-4 fs-2" ></i>  
        <div class="fw-semibold mt-2" style="font-size: 16px;">Lists</div>
      </div>
    </RouterLink>
  </div>

   <div class="col-6 col-md-6 col-lg-2">
    <div to="/lists" class="menu-box d-block">
      <div class="menu-content">
         <i class="icofont-ui-messaging menu-img mb-2 mt-4 fs-2" ></i>  
        <div class="fw-semibold mt-2" style="font-size: 16px;">SMS <br>(Coming soon)</div>
      </div>
    </div>
  </div>

   <div class="col-6 col-md-6 col-lg-2">
    <div to="/lists" class="menu-box d-block">
      <div class="menu-content">
         <i class="icofont-ui-message menu-img mb-2 mt-4 fs-2" ></i>  
        <div class="fw-semibold mt-2" style="font-size: 16px;">Newsletter <br>(Coming soon)</div>
      </div>
    </div>
  </div>

   <div class="col-6 col-md-6 col-lg-2">
    <div to="/lists" class="menu-box d-block">
      <div class="menu-content">
         <i class="icofont-cocktail menu-img mb-2 mt-4 fs-2" ></i>  
        <div class="fw-semibold mt-2" style="font-size: 16px;">Γιορτές <br>(Coming soon)</div>
      </div>
    </div>
  </div>

     <div class="col-6 col-md-6 col-lg-2">
    <div to="/lists" class="menu-box d-block">
      <div class="menu-content">
         <i class="icofont-birthday-cake menu-img mb-2 mt-4 fs-2" ></i>  
        <div class="fw-semibold mt-2" style="font-size: 16px;">Γενέθλια <br>(Coming soon)</div>
      </div>
    </div>
  </div>

 
</div>

                           
                        </div>
                    </div>

</template>



<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { useRoute, useRouter } from 'vue-router';
import 'vue-toastification/dist/index.css';
import { mapGetters } from 'vuex';

export default {
    name: 'CRM Menu',
     computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',
      getUserPackets: 'getUserPackets'
    }),
    userPermissionsProjects() {
      return this.getUserPermission('Projects');
    },
    canViewProjects() {
      return this.userPermissionsProjects?.view === 1;
    },
    userPermissionsUsers() {
      return this.getUserPermission('Users');
    },
    canViewUsers() {
      return this.userPermissionsUsers?.view === 1;
    },
    userPermissionsServices() {
      return this.getUserPermission('Services');
    },
    canViewServices() {
      return this.userPermissionsServices?.view === 1;
    },
    userPermissionsSuppliers() {
      return this.getUserPermission('Suppliers');
    },
    canViewSuppliers() {
      return this.userPermissionsSuppliers?.view === 1;
    },
    userPermissionsClients() {
      return this.getUserPermission('Clients');
    },
    userPermissionsDashboard() {
      return this.getUserPermission('Dashboard');
    },
    canViewClients() {
      return this.userPermissionsClients?.view === 1;
    },
    userPermissionsContacts() {
      return this.getUserPermission('Contacts');
    },
    userPermissionsLists() {
      return this.getUserPermission('Lists');
    },
    userPermissionsGroups() {
      return this.getUserPermission('Service Categories');
    },
    canViewContacts() {
      return this.userPermissionsContacts?.view === 1;
    },
    canViewLists() {
      return this.userPermissionsLists?.view === 1;
    },
    canViewGroups() {
      return this.userPermissionsGroups?.view === 1;
    },
    userPermissionsHours() {
      return this.getUserPermission('Hours');
    },
    canViewHours() {
      return this.userPermissionsHours?.view === 1;
    },
    userPermissionsHolidays() {
      return this.getUserPermission('Holidays');
    },
    canViewHolidays() {
      return this.userPermissionsHolidays?.view === 1;
    },

    userPermissionsReporting() {
      return this.getUserPermission('Reporting');
    },
    canViewReporting() {
      return this.userPermissionsReporting?.view === 1;
    },
    userPermissionsDaysOff() {
      return this.getUserPermission('Days off');
    },
    canViewDaysOff() {
      return this.userPermissionsDaysOff?.view === 1;
    },
    userPermissionsDaysOffReports() {
      return this.getUserPermission('Days off reports');
    },
    canViewDaysOffReports() {
      return this.userPermissionsDaysOffReports?.view === 1;
    },
    canViewDashboard() {
      return this.userPermissionsDashboard?.view === 1;
    },
    superUser() {
      return this.getSuperUserPermission === 1;
    },

    // Packet-based feature flags
  hasCRM() {
    return this.getUserPackets.includes('CRM');
  },
  hasHR() {
    return this.getUserPackets.includes('HR');
  },
  hasProjectManagement() {
    return this.getUserPackets.includes('PROJECT MANAGEMENT');
  },
  hasMarketingHub() {
    return this.getUserPackets.includes('MARKETING HUB');
  },
  // Add more like:
  hasMED() {
    return this.getUserPackets.includes('MED');
  }
  },
    
    metaInfo: {
        title: 'CRM Menu',
        meta: [
            { name: 'description', content: 'CRM Menu' },
            { property: 'og:title', content: 'CRM Menu' },
            { property: 'og:description', content: 'This is the CRM Menu page.' }
        ]
    }
};

</script>

<style scoped>
.checkbox-wrapper {
  margin-right: 10px;
}

.user-info {
  flex-grow: 1;
}
.userInfoText {
  margin-top: 10px;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
tr.selected, div.selected {
    background: #b1afaf;
}
.nav-tabs.prtab-set {
  background: #f9fafb;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  width: 200px;
}

.nav-tabs.prtab-set .nav-item {
  flex: 1;
}

.nav-tabs.prtab-set .nav-link {
  border: none;
  /* padding: 1rem 0; */
  font-weight: 600;
  color: #6b7280; /* Gray-600 */
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  border-radius: 0;
  width: 100%;
  box-shadow: inset 1px 1px 10px 0px #e8e8e8;
}

.nav-tabs.prtab-set .nav-link:hover {
  background-color: #e5e7eb; /* Gray-200 */
  color: #111827; /* Gray-900 */
}

.nav-tabs.prtab-set .nav-link.active {
  background-color: #a0a0a0; /* Blue-500 */
  color: #ffffff;
  border-radius: 0;
  box-shadow: inset 0 -3px 0 #858585; /* Blue-600 underline effect */
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* Ensures content is centered inside the box */
}


.menu-img {
  width: 5em;
}

.row.text-center.g-3 {
  align-items: stretch; /* ensures children fill equal height */
}


@media screen and (max-width: 768px) {
    .nav-tabs.prtab-set{
        width: 100%;
        margin-bottom: 20px;
    }
    .newuserbtn{
        width: 100%;
        margin-right: 20px;
    }
    .gridmob{
        flex-direction: column;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
    }
    .checkbox-wrapper{
        margin-right: 0px;
    }
}
</style>
